<template>
  <div class="back-to-top">
    <div @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave" @click="routerJump()">
      <img src="../assets/img/wx.png" alt="">
      <p>联系客服</p>
    </div>
    <div v-if="showButton" @click="scrollTop">
      <img src="../assets/img/top.png" alt="">
      <p>返回顶部</p>
    </div>
    <div v-if="showLargeImage" class="bigImg">
      <img src="../assets/img/bigWx.png" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BackToTop',
  data() {
    return {
      showButton: false,
      showLargeImage: false
    };
  },
  methods: {
    routerJump() {
      window.open('https://work.weixin.qq.com/kfid/kfcd89dbcb745241884')
    },
    handleMouseEnter() {
      console.log('mouse enter');
      this.showLargeImage = true;
    },
    handleMouseLeave() {
      this.showLargeImage = false;
    },
    scrollTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    handleScroll() {
      if (window.scrollY > 300) { // 设置滚动到多少像素时显示按钮
        this.showButton = true;
      } else {
        this.showButton = false;
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }
};
</script>

<style scoped lang="less">
.back-to-top {
  position: fixed;
  right: 20px;
  top: 75vh;
  width: 68px;
  background-color: rgba(255, 255, 255, 1);
  color: white;
  border: none;
  cursor: pointer;
  box-shadow: 0px 0px 16px 0px rgba(0,0,0,0.1);
  border-radius: 2px;
  z-index: 1000;
  >div {
    margin: 4px;
    display: flex;
    flex-direction: column;
    height: 60px;
    img {
      margin: 8px 18px;
      width: 24px;
      height: 24px;
    }
    
    p {
      color: rgba(0, 0, 0, 0.40);
      font-size: 12px;
      font-weight: bold;
      text-align: center;
    }
  }
  >div:hover {
    p {
      color: rgba(24, 144, 255, 1);
    }
  }
  >div:nth-child(2) {
    border-top: 1px solid rgba(0, 0, 0, 0.10);
  }
  .bigImg {
    position: fixed;
    top: 74vh;
    right: 92px;
    width: 222px;
    height: 222px;
    box-sizing: border-box;
    background-color: #fff;
    box-shadow: 0px 0px 16px 0px rgba(0,0,0,0.1);
    border-radius: 2px;
    img {
      margin: 0;
      width: 222px;
      height: 222px;
    }
  }
}
</style>
